<script setup>
  import { ref, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { apiService } from '@/services/api'
  import { useDialogStore } from '@/stores/dialogStore'
  import { useUserStore } from '@/stores/userStore'
  import FooterNoneLogin from '@/components/FooterNoneLogin.vue'

  const router = useRouter()
  const route = useRoute()

  const dialogStore = useDialogStore()
  const userStore = useUserStore()

  const showPassword = ref(false)
  const showPasswordConfirmation = ref(false)

  // フォーム用データ
  const form = ref(null)
  const formData = ref({
    email: '',
    password: '',
    passwordConfirmation: '',
    token: '',
  })

  // URL パラメータからメールアドレスとトークンを取得
  onMounted(() => {
    // URLクエリパラメータからemailとtokenを取得
    if (route.query.email) {
      formData.value.email = route.query.email
    }
    if (route.params.token) {
      formData.value.token = route.params.token
    } else if (route.query.token) {
      formData.value.token = route.query.token
    }
  })

  // パスワードリセット処理
  const resetPassword = async () => {
    try {
      const response = await apiService.post('api/password/reset', formData.value)
      if (await dialogStore.showMessageDialog('パスワードを変更しました', 'ログイン画面に戻ります')) {
        router.push('/login')
      }
    } catch (error) {}
  }
</script>

<template>
  <header></header>
  <main class="login-main">
    <div class="login-content">
      <form @submit.prevent="resetPassword" ref="form" method="post">
        <h1><img class="logo" src="@/assets/img/login_logo.svg" alt="ディーモ for 社労士" /></h1>
        <h2>パスワード再設定</h2>
        <div class="form-grid">
          <div class="login-input type-password">
            <label>新しいパスワード</label>
            <input v-if="showPassword" type="text" v-model="formData.password" />
            <input v-else type="password" name="password" id="password" v-model="formData.password" />
            <button type="button" class="show-password" @click="showPassword = !showPassword">
              <span class="material-symbols-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
            </button>
          </div>

          <div class="login-input type-password">
            <label>パスワード再入力</label>
            <input v-if="showPasswordConfirmation" type="text" v-model="formData.passwordConfirmation" />
            <input v-else type="password" name="password_confirmation" id="password_confirmation" v-model="formData.passwordConfirmation" />
            <button type="button" class="show-password" @click="showPasswordConfirmation = !showPasswordConfirmation">
              <span class="material-symbols-outlined">{{ showPasswordConfirmation ? 'visibility_off' : 'visibility' }}</span>
            </button>
          </div>

          <button class="input-submit" type="submit" :disabled="formData.password === '' || formData.passwordConfirmation === ''">パスワードを変更する</button>
        </div>
      </form>
    </div>
  </main>
  <FooterNoneLogin />
</template>
<style lang="less" scoped>
  .login-content .login-input.type-password {
    grid-template-columns: 100px 1fr 30px !important;
  }
</style>
